import { render, staticRenderFns } from "./ModalProcessBackground.vue?vue&type=template&id=6a99a38b&scoped=true"
import script from "./ModalProcessBackground.vue?vue&type=script&lang=js"
export * from "./ModalProcessBackground.vue?vue&type=script&lang=js"
import style0 from "./ModalProcessBackground.vue?vue&type=style&index=0&id=6a99a38b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a99a38b",
  null
  
)

export default component.exports